<div class="header">
  <span>
    {{ label }}
  </span>
  <div>
    <app-button icon="chevron_left" (click)="prev()"></app-button>
    <app-button icon="chevron_right" (click)="next()"></app-button>
  </div>
</div>
